<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="my-wrap container">
      <titleConfig
        :title="langSet == 'cn' ? '我的商机' : 'My Business Opportunity'"
        :type="2"
      ></titleConfig>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="langSet == 'cn' ? '我的需求' : 'My Request'"
          name="publish"
        >
          <businessList
            :businessList="publishListData"
            :external="'business'"
            @item_click="item_click"
          ></businessList>
          <nodata v-if="publishListData.length == 0"></nodata>
        </el-tab-pane>
        <el-tab-pane
          :label="langSet == 'cn' ? '我的应答' : 'My Response'"
          name="reply"
        >
          <businessList
            :businessList="replyListData"
            :external="'business'"
            @item_click="item_click"
          ></businessList>
          <nodata v-if="replyListData.length == 0"></nodata>
        </el-tab-pane>
        <el-tab-pane
          :label="langSet == 'cn' ? '我的索样' : 'Request Sample'"
          name="mineProduct"
        >
          <productList
            :productLists="listData"
            :external="'product'"
            @item_click="item_click"
          ></productList>
          <nodata v-if="listData.length == 0"></nodata>
        </el-tab-pane>
      </el-tabs>
      <AskingForSamples
        v-if="Samples_dialogVisible"
        :type="'see'"
        :form_details="form_details"
        :dialog_release="Samples_dialogVisible"
        @add_request="product_show"
      ></AskingForSamples>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>


<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import titleConfig from "@/components/title.vue";
import nodata from "@/components/nodata.vue";
import businessList from "../business/component/business_list.vue";
import productList from "./components/product_list.vue";
import { publishList, replyList, consultationList } from "@/api/api";
import AskingForSamples from "@/views/product/component/AskingForSamples.vue";

export default {
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.title,
      meta: [
        {
          name: "description",
          content: this.metaData.desc,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  components: {
    AskingForSamples,
    top,
    bottom,
    titleConfig,
    nodata,
    businessList,
    productList,
  },
  data() {
    return {
      metaData: {},
      Samples_dialogVisible: false,
      form_details: {},
      langSet: "",
      activeName: "publish",
      publishListData: [], //发布列表
      replyListData: [], //应答列表
      listData: [], //索样列表 留言列表
    };
  },
  created() {},
  mounted() {
    this.langSet = this.$language;
    this.metaData = JSON.parse(localStorage.getItem("metaData"));
    this.getPublishList();
  },
  methods: {
    async getPublishList() {
      const res = await publishList();
      if (res.data.count) {
        this.publishListData = res.data.lists;
      }
    },
    async getReplyList() {
      const res = await replyList();
      if (res.data.count) {
        this.replyListData = res.data.lists;
      }
    },
    async getConsultationList() {
      const res = await consultationList();
      if (res.data.count) {
        this.listData = res.data.lists;
      }
    },
    //跳转详情
    item_click(item, type) {
      if (type == "product") {
        this.product_show();
        this.form_details = item;
      } else if (type == "company") {
        this.$router.push({
          path: "/company",
          query: {
            detail_show: true,
            exhibitor_long_id: item.exhibitor_long_id,
          },
        });
      } else if (type == "business") {
        this.$router.push({
          path: "/businessDetail",
          query: {
            id: item.id,
          },
        });
      }
    },
    product_show() {
      this.Samples_dialogVisible = !this.Samples_dialogVisible;
    },
    handleClick(tab) {
      this.activeName = tab.name;
      switch (tab.name) {
        case "reply":
          this.getReplyList();
          break;
        case "mineProduct":
          this.getConsultationList();
          break;
        case "mineExhibitor":
          this.getConsultationList();
          break;
        default:
          this.getPublishList();
          break;
      }
    },
  },
};
</script>


<style scoped lang="scss">
.my-wrap {
  padding: 80px 0;
  .title_wrap {
    margin-bottom: 30px;
  }
}
/deep/ .el-tabs {
  min-height: 500px;
}
/deep/ .el-tabs__nav-wrap::after {
  display: none;
}
/deep/ .el-tabs__header {
  margin-bottom: 30px;
}
/deep/ .el-tabs__item {
  min-width: 120px;
  height: 42px;
  padding: 0 10px !important;
  font-weight: 400;
  font-size: 16px;
  color: #444;
  line-height: 42px;
  text-align: center;
  background: #eee;
  margin-right: 20px;
  border-radius: 21px;
  box-sizing: border-box;
}
/deep/ .el-tabs__active-bar {
  display: none;
}
/deep/ .el-tabs__item.is-active {
  color: #fff;
  font-weight: 500;
  background: #1d2379;
}

@media only screen and (max-width: 767px) {
  .my-wrap {
    padding: 0.58rem 0;
    /deep/ .el-tabs__item {
      width: 1.71rem;
      height: 0.65rem;
      font-size: 0.27rem;
      line-height: 0.65rem;
      margin-right: 0.29rem;
    }
    /deep/ .el-tabs__nav-next,
    /deep/ .el-tabs__nav-prev {
      line-height: 35px;
    }
  }
}
</style>